var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6051 22.7438C46.3807 32.8139 39.6567 42.4168 29.5866 44.1925L13.1649 47.0881C11.5539 47.3721 10.4008 45.5504 11.3374 44.2008L14.2713 39.9734C11.1536 37.2848 8.90857 33.5445 8.13792 29.174C6.36229 19.1038 13.0863 9.50096 23.1564 7.72533C33.2265 5.9497 42.8294 12.6737 44.6051 22.7438ZM31.1881 19.0801C32.0257 19.6666 32.2293 20.8211 31.6428 21.6587L28.9501 25.5042L32.7956 28.1969C33.6332 28.7834 33.8368 29.9379 33.2503 30.7755C32.6638 31.6131 31.5093 31.8167 30.6717 31.2302L26.8262 28.5375L24.1335 32.383C23.547 33.2206 22.3925 33.4242 21.5549 32.8377C20.7173 32.2512 20.5137 31.0967 21.1002 30.2591L23.7929 26.4136L19.9474 23.7209C19.1097 23.1344 18.9062 21.9799 19.4927 21.1423C20.0792 20.3047 21.2337 20.1011 22.0713 20.6876L25.9168 23.3803L28.6095 19.5348C29.196 18.6971 30.3505 18.4936 31.1881 19.0801Z",
    fill: "#FF507A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e721346d524738947769ea086a866999.svg";
export { ForwardRef as ReactComponent };